import {
  LayoutDashboard, Trophy, Calculator, Sparkles, TrendingUp,
  Newspaper, Bot, GraduationCap, History, Swords, Briefcase,
  Telescope, ArrowLeftRight, Wallet, Gauge, Brain, BarChart3, Gift, GitCompare,
} from "lucide-react";

// Single source of truth for the app's navigation tabs — consumed by the desktop Sidebar
// and the mobile Home ("All Tools") launcher so the two never drift out of sync.
export const NAV_LINKS = [
  { to: "/app", label: "Dashboard", icon: LayoutDashboard, end: true, tid: "nav-dashboard" },
  { to: "/app/values", label: "DME Player Values", icon: BarChart3, tid: "nav-dme-values" },
  { to: "/app/command", label: "Command Center", icon: Gauge, tid: "nav-command", pro: true },
  { to: "/app/portfolio", label: "Multi-League Portfolio", icon: Briefcase, tid: "nav-portfolio", pro: true },
  { to: "/app/league-intel", label: "DME League Intelligence", icon: Brain, tid: "nav-league-intel", pro: true },
  { to: "/app/pick-arbitrage", label: "Pick Arbitrage", icon: ArrowLeftRight, tid: "nav-arbitrage", pro: true },
  { to: "/app/ledger", label: "League Ledger", icon: Wallet, tid: "nav-ledger", pro: true },
  { to: "/app/devy", label: "Prospect Pipeline", icon: Telescope, tid: "nav-devy", pro: true },
  { to: "/app/power-rankings", label: "Power Rankings", icon: Trophy, tid: "nav-power" },
  { to: "/app/trade-calculator", label: "Trade Calculator", icon: Calculator, tid: "nav-tradecalc" },
  { to: "/app/compare", label: "Compare Players", icon: GitCompare, tid: "nav-compare" },
  { to: "/app/advisor", label: "AI Trade Advisor", icon: Bot, tid: "nav-advisor", pro: true },
  { to: "/app/trade-finder", label: "Trade Finder", icon: Sparkles, tid: "nav-tradefinder", pro: true },
  { to: "/app/draft", label: "Rookie Draft & ADP", icon: GraduationCap, tid: "nav-draft", pro: true },
  { to: "/app/mock-draft", label: "Mock Draft", icon: Swords, tid: "nav-mock", pro: true },
  { to: "/app/market", label: "Market Trends", icon: TrendingUp, tid: "nav-market" },
  { to: "/app/trade-history", label: "Trade History", icon: History, tid: "nav-history", pro: true },
  { to: "/app/news", label: "Squad News", icon: Newspaper, tid: "nav-news", pro: true },
  { to: "/app/referral", label: "Refer & Earn", icon: Gift, tid: "nav-referral" },
];
